import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { RouteService, StorageService } from '../services';
import { IRestrictions } from 'src/app/models';
import { RestrictionsQueryParam } from 'src/app/models/enums';
import { initialPaginationState } from '../store/initialisation/pagination';
import { initialRestrictionsState } from '../store/initialisation/restrictions';
import { APP } from '../config/app';

@Injectable({
  providedIn: 'root',
})
export class RestrictionsResolver {

  constructor(private routeService: RouteService, public storageService: StorageService) {}

  async resolve(route: ActivatedRouteSnapshot, searchValue?: string) {
    this.storageService.setRouteName('services');
    const routeId = Number(route.paramMap.get('routeId'));
    const pageFromUrl = Number(route.queryParamMap.get(RestrictionsQueryParam.PAGE));
    const page = pageFromUrl > 0 ? pageFromUrl : 1;
    const size = await this.getPageSize(route);

    // Blank the list so the skeleton shows while the fetch is in flight; totals
    // are kept so the pagination doesn't collapse on a pure page change.
    initialRestrictionsState.isFetchingRestrictions = true;
    initialRestrictionsState.value = [];

    const {
      content,
      numberOfElements,
      totalElements,
      totalPages,
      first,
      last,
    } = await this.routeService.getRestrictions(routeId, page, size, searchValue);
    return this.getData(
      content,
      numberOfElements,
      totalElements,
      totalPages,
      first,
      last,
      page,
      size,
    );
  }

  async getPageSize(route: ActivatedRouteSnapshot): Promise<number> {
    const sizeFromUrl = Number(route.queryParamMap.get(RestrictionsQueryParam.SIZE));
    return sizeFromUrl > 0 ? sizeFromUrl : (await this.storageService.getRestrictionsPageSize()) || APP.MAX_PAGE_SIZE;
  }

  getData(
    content: IRestrictions[],
    numberOfElements: number,
    totalElements: number,
    totalPages: number,
    first: boolean,
    last: boolean,
    page: number,
    size: number = APP.DEFAULT_PAGE_SIZE,
  ) {
    // Mutates the shared state object so the component's reference stays live across re-resolves
    const data = initialRestrictionsState;
    data.value = content ?? [];
    data.isFetchingRestrictions = false;
    data.pagination = {...initialPaginationState};
    data.pagination.numberOfElements = numberOfElements;
    data.pagination.totalPages = totalPages;
    data.pagination.totalElements = totalElements;
    data.pagination.actualPage = page;
    data.pagination.first = first;
    data.pagination.last = last;
    data.pagination.size = size;
    return data;
  }
}
